import styled, { css, keyframes } from 'styled-components';
import dsTokens from '@frete.com/fuel-foundation/fretebras/theme.json';

export interface PulsePropsInterface {
  isPulse: boolean;
  backgroundColor: string;
  shadowColor: string;
  hasFuelIcon: boolean;
  align?: 'left' | 'center';
  size?: 'sm' | 'md';
}

const PulseOpacity = (color: string) => keyframes`
0% {
  transform: scale(0.97);
  box-shadow: 0 0 0 0 ${color};
}

70% {
  transform: scale(1);
  box-shadow: 0 0 0 4px rgba(0, 0, 0, 0);
}

100% {
  transform: scale(0.97);
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
}
`;

const sizeCircle = dsTokens.spacing.km3;

export const Pulse = styled.div<PulsePropsInterface>`
  ${({
    theme,
    isPulse,
    backgroundColor,
    shadowColor,
    hasFuelIcon,
    align,
    size,
  }) => css`
    position: relative;
    display: grid;
    justify-content: flex-start;
    align-items: center;
    padding-left: ${theme.spacing.km5};

    :before {
      content: '';
      ${!hasFuelIcon &&
      css`
        position: absolute;
        width: ${sizeCircle};
        height: ${sizeCircle};
        border-radius: 50%;
        top: 6px;
        left: 0px;
        display: block;
        box-sizing: border-box;
        background: ${backgroundColor};

        ${align === 'center' &&
        css`
          left: calc(50% - ${parseInt(sizeCircle, 10) / 2}px);
        `}

        ${size === 'sm' &&
        css`
          width: ${theme.spacing.km2};
          height: ${theme.spacing.km2};
          left: calc(50% - ${parseInt(theme.spacing.km2, 10) / 2}px);
        `}

        ${isPulse &&
        css`
          background: ${backgroundColor};
          box-shadow: 0px 0px 0px 4px ${backgroundColor};
          animation: ${PulseOpacity(shadowColor)} 1s infinite;
        `}
      `}
    }
  `}
`;

const sizeIcon = dsTokens.spacing.km4;

interface IconWrapperProps {
  color: string;
}

export const IconWrapper = styled.div<IconWrapperProps>`
  ${({ color }) => css`
    position: absolute;
    color: ${color};
    width: ${sizeIcon};
    height: ${sizeIcon};
    top: 3px;
    left: calc(50% - ${parseInt(sizeIcon, 10) / 2}px);
  `}
`;
